// Adopted from
// http://www.prideparrot.com/blog/archive/2019/3/how_to_create_custom_dropdown_cdk
export * from "./internals";

export * from "./main-search-box.component";
